import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { MessageService } from "./message.service";

@Injectable({
    providedIn: 'root'
})

export class ReportService {

    private reportUrl = location.origin + '/api/report/';

    private token = localStorage.getItem('token');

    private headers = new HttpHeaders().set('Content-Type', 'application/json');
    private httpOptions = this.headers.append('Authorization', `Bearer ${this.token}`);

    constructor(private http: HttpClient, private messageService: MessageService) { }

    private getToken() {
        return this.headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    }

    initReport(): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}init`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    createReport(dataJson: any): Observable<any> {
        return this.http.post<any>(`${this.reportUrl}create`, dataJson, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getTableReports(isAdmin): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}list?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getTableCandidates(isAdmin): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}candidate/list?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getReportDetail(requestNumber: String): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}detail/${requestNumber}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    validateUUID(requestNumber: String, uuid: String): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}valid/${requestNumber}/${uuid}`)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    updateCandidatePrivacy(requestNumber: String, uuid: String): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}candidate/privacy/update/${requestNumber}/${uuid}`)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    privacyCheckedorNot(requestNumber: String, uuid: String): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}candidate/privacy/checked/${requestNumber}/${uuid}`)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
            );
    }

    updateCandidate(requestNumber: any, uuid: any, dataJson: any): Observable<any> {
        return this.http.post<any>(`${this.reportUrl}candidate/update/${requestNumber}/${uuid}`, dataJson)
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    createCandidateVisura(dataJson: any): Observable<any> {
        return this.http.post<any>(`${this.reportUrl}candidate/visura`, dataJson, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getCandidateDetail(requestNumber: any, uuid: any): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}candidate/get/${requestNumber}/${uuid}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getReportsCountForDashboard(adminUser): Observable<any> {
        return this.http.get<any>(`${this.reportUrl}dashboard/count?admin=${adminUser}`, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }

    getReportsForDashboardGraph(dataJson: any, adminUser): Observable<any> {
        return this.http.post<any>(`${this.reportUrl}dashboard/graph?admin=${adminUser}`, dataJson, { headers: this.getToken() })
            .pipe(
                tap(() => this.messageService.add('fetched data')),
                // catchError(this.handleError<any>('form added'))
            );
    }
}